import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class ValidatorsService {

  constructor() {
  }

  isValidPhone(phoneNumber: string | null | undefined): boolean {
    if (!phoneNumber) return false;
    phoneNumber = phoneNumber.replace(/\s+/g, ''); //eliminamos espacios
    console.log("number", phoneNumber);
    return /^\+[1-9][0-9]{7,14}$/.test(phoneNumber); // Formato: +123123456789
  }

  isValidEmail(email: string | null | undefined): boolean {
    if (!email) return false;
    return /\S+@\S+\.\S+/.test(email);
  }

  hasAtLeastOneContactMethod(email?: string, phone?: string): boolean {
    return !!email || !!phone;
  }

  isPhonePrefixRequired(prefix?: string, phone?: string): boolean {
    if (phone && !prefix) return false;
    return true;
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      return this.isValidEmail(control.value) ? null : { emailInvalid: true };
    };
  }

  phoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;
      const prefixControl = group.get('phonePrefix')!;
      const phoneControl = group.get('phoneNumber')!;

      const prefix = prefixControl.value != null ? prefixControl.value.dial_code : '';
      const phone = phoneControl.value || '';

      prefixControl.setErrors(null);
      phoneControl.setErrors(null);
      const errors: ValidationErrors = {};

      var phoneNumber = prefix + phone;

      if (phone != '' && (!prefix || prefix === '' || prefix === '-1')) {
        errors['phonePrefixRequired'] = true;
        prefixControl.setErrors({phonePrefixRequired: true});
        prefixControl.markAsTouched();
      }

      if (phone != '' && prefix != '' && prefix != '-1' && !this.isValidPhone(phoneNumber)) {
        errors['phoneInvalid'] = true;
        phoneControl.setErrors({ phoneInvalid: true });
        phoneControl.markAsTouched();
      } 

      return Object.keys(errors).length > 0 ? errors : null;
    };
  }

  atLeastOneContactMethod(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formValue = control.getRawValue();
      const hasPhone = formValue.phonePrefix && formValue.phonePrefix !== '-1' && formValue.phonePrefix !== '' && formValue.phoneNumber && formValue.phoneNumber.toString().trim().length > 0;

      const hasEmail = formValue.email && formValue.email.toString().trim().length > 0;

      return !hasPhone && !hasEmail ? { atLeastOneRequired: true } : null;
    };
  }

  phonePrefixRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formValue = control.getRawValue();

      const hasPhoneNumber = formValue.phoneNumber && formValue.phoneNumber.toString().trim().length > 0;
      const hasValidPrefix = formValue.phonePrefix && formValue.phonePrefix !== '-1' && formValue.phonePrefix !== '';

      return hasPhoneNumber && !hasValidPrefix ? { phonePrefixRequired: true } : null;
    };
  }
}
